module.exports = __webpack_public_path__ + "media/images/media/images/pic/teachers/anna-sielawko-422264c6253fd562211d7762c5839913.webp";